// React
import { useEffect } from 'react';

// Store
import useProfileStore from '../../store/profileStore.js';
import useSiteStore from '../../store/siteStore.js'

// Hooks
import { useAppTheme } from '../../hooks/useAppTheme.js';

// Component
import { Box, useMediaQuery } from '@mui/material';
import EditProfile from './EditProfile/index.js';
import DashboardAppBar from './DashboardAppBar.js';
import DashboardCoach from './Coach/index.js';
import DashboardAthlete from './Athlete/index.js';
import DashboardParent from './Parent/index.js';

function Dashboard() {
	const { profile, profileType } = useProfileStore();
	const { setMobile } = useSiteStore();
	const { colors } = useAppTheme();
	const smallP = useMediaQuery('(max-width:600px)');
	const largeP = useMediaQuery('(max-width:712px)');

	useEffect(() => {
		if(!profileType) 
			return;

		const typesWithSmallP = ['nationalCoach', 'coach'];
		setMobile(typesWithSmallP.includes(profileType) ? smallP : largeP);
	}, [profileType, setMobile, smallP, largeP]);

	return (
		profile && (
		<Box sx={{ 
			minHeight: '100vh',
			backgroundColor: colors.bg,
			transition: 'background-color 0.3s ease',
		}}>
			<EditProfile/>
			
			<DashboardAppBar/>{ (() => {
				switch (profileType) {
					case 'coach':
					case 'nationalCoach':
						return <DashboardCoach />;
					case 'athlete':
						return <DashboardAthlete />;
					case 'parent':
						return <DashboardParent />;
					default:
						return null;
				}
			  })()
			}
		</Box>
		)
	);
}

export default Dashboard;